import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
// @import '~antd/dist/antd.less';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import enUS from "antd/lib/locale/en_US";
import "./i18n";

const Main = () => {
  const [l, setL] = useState("en");
  useEffect(() => {
    setL(localStorage.getItem("i18nextLng"));
    console.log(localStorage.getItem("i18nextLng"));
  }, [localStorage.getItem("i18nextLng")]);
  return (
    <BrowserRouter>
      <ConfigProvider locale={l == "en" ? enUS : zhCN}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  );
};
ReactDOM.render(<Main />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
